import { Injectable } from '@angular/core';
import { UntypedFormGroup, ValidationErrors, UntypedFormArray } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { MessageService } from 'primeng/api';

@Injectable()
export class ErrorBindingService {
  message = new BehaviorSubject<any>('');

  constructor(
  ) { }

  onAPIValidationError(error, errorList) {

    for (const k in error) {
      if (error.hasOwnProperty(k)) {
        errorList[0][k] = true;
        errorList[k] = error[k];
        this.hideErrorMessage(errorList, k);
        break;
      }
    }
  }

  onAPIValidationSuccess(response, errorList) {
    for (const k in response) {
      if (response.hasOwnProperty(k)) {
        errorList[0][k] = true;
        errorList[k] = response[k];
        this.hideErrorMessage(errorList, k);
        break;
      }
    }
  }

  onAPIValidationErrorWithoutHideMsg(error, errorList) {
    for (const k in error) {
      if (error.hasOwnProperty(k)) {
        errorList[0][k] = true;
        errorList[k] = error[k];
        setTimeout(() => {
          if (document.getElementById('error-id')) {
            document.getElementById('error-id').getElementsByTagName('div')[0].focus()
          }
        })
        break;
      }
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  hideErrorMessage(errorList, k) {
    setTimeout(() => {
      errorList[0][k] = false;
    }, 5000);
  }

  getFormValidationErrors(formGroup: UntypedFormGroup, index?: number) {
    let setFirstFocus = true;
    Object.keys(formGroup.controls).forEach((key) => {
      const controlErrors: ValidationErrors = formGroup.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(() => {
          if (setFirstFocus && document.getElementById(key)) {
            document.getElementById(key).focus();
            setFirstFocus = false;
          }

          if (setFirstFocus && document.getElementById(key + index)) {
            document.getElementById(key + index).focus();
            setFirstFocus = false;
          }
        });
      }

      const formArray = (<UntypedFormArray>formGroup.get(key));
      if (formArray.length > 0) {
        for (let i = formArray.length - 1; i >= 0; i--) {
          if (setFirstFocus) {
            this.getFormValidationErrors(<UntypedFormGroup>formArray.controls[i], i);
          }
        }
      }
    });
  }

  setMessage(message: any) {
    this.message.next(message);
  }
}
